/**
 * Centralized translations for LIS-related screens.
 * Contains labels used across LIS Alert Management and LIS data exploration components.
 */

export const LisLabels = {
    it: {
        // Page title and sections
        lisAlertManagement: 'Gestione LIS Alert',
        lisAlertManagementDescription: 'Gestisci vocabolari LIS, mappature e regole di alert',
        vocabularyManagement: 'Gestione Vocabolari',
        statusMonitor: 'Monitoraggio Stato',
        systemStatusMonitor: 'Monitoraggio Stato Sistema',
        systemStatusMonitorDescription: 'Monitora lo stato dei sistemi',
        "LIS Source Data Table": "Tabella Dati Sorgente LIS",
        "Manage source data table records": "Gestisci i record della tabella dati sorgente",
        errorLegendTitle: "Legenda Errori",
        // System Status Monitor (new)
        sourceDataImportSection: 'Import Dati Sorgente',
        dataAnalysisVerificationSection: 'Job Analisi/Verifica Dati',
        lisToAiPlanLocalDbTitle: 'LIS verso DB locale AI-Plan',
        postImportProcessingTitle: 'Elaborazione post-import',
        statusRunningBadge: 'STATO: IN ESECUZIONE',
        statusIdleBadge: 'STATO: IDLE',
        lastImportEnded: 'Ultimo Import Terminato',
        // Job status labels
        sourceDataImport: 'Import Dati Sorgente (LIS → AI-PLAN DB Locale)',
        dataAnalysisJob: 'Job Analisi/Verifica Dati (Post-Import)',
        status: 'Stato',
        lastImportStarted: 'Ultimo Import Avviato',
        lastStatus: 'Ultimo Stato',
        details: 'Dettagli',
        noErrorsReported: 'Nessun errore segnalato',
        ATC_Code: 'Codice ATC',
        Antibiotic: 'Antibiotico',
        Class: 'Classe',
        Category: 'Categoria',
        ListedEML: 'Lista EML',

        
        // Status values
        idle: 'IDLE',
        running: 'IN ESECUZIONE',
        completed: 'COMPLETATO',
        failed: 'FALLITO',
        ok: 'OK',
        error: 'Errore',
        notAvailable: 'N/D',
        
        // Vocabulary types
        antibiotics: 'Antibiotici',
        antibioticsVoc: 'Vocabolario Antibiotici AWARE',
        materials: 'Materiali',
        materialsVoc: 'Vocabolario Materiali',
        microorganisms: 'Microrganismi',
        microorganismsVoc: 'Vocabolario Microrganismi',
        antibioticsMap: 'Mappatura Antibiotici',
        antibioticsMapping: 'Mappatura LIS → AWARE Antibiotici',
        materialsMap: 'Mappatura Materiali',
        materialsMapping: 'Mappatura LIS → Materiali',
        microorganismsMap: 'Mappatura Microrganismi',
        microorganismsMapping: 'Mappatura LIS → Microrganismi',
        alertRules: 'Regole Alert',
        alertRulesManagement: 'Gestione Regole Alert',
        provenienza: 'Provenienza',
        provenienzaVoc: 'Vocabolario Provenienza',
        analisi: 'Analisi',
        analisiVoc: 'Vocabolario Analisi Microbiologiche',
        analisiMapping: 'Mappatura Analisi',
        
        // Actions
        addRow: 'Aggiungi Riga',
        importFromExcel: 'Importa da Excel',
        exportToExcel: 'Esporta in Excel',
        save: 'Salva',
        cancel: 'Annulla',
        delete: 'Elimina',
        edit: 'Modifica',
        refresh: 'Aggiorna',
        download: 'Scarica',
        upload: 'Carica',
        saveChanges: 'Salva Modifiche',
        saveAllChanges: 'Salva tutte le modifiche',
        noChangesToSave: 'Nessuna modifica da salvare',
        cancelEditing: 'Annulla modifica',
        replaceVocabulary: 'Importa Vocabolario',
        saveVocabulary: 'Salva Vocabolario',
        selectVocabularyToEdit: 'Seleziona il vocabolario da modificare',
        editing: 'In modifica',
        viewing: 'Visualizzazione',
        importProgress: 'Progresso importazione',
        activeNull: 'Attivo (NULL)',
        primaryKeyReadonly: 'Chiave primaria - non modificabile',
        
        // Table columns
        validFrom: 'Valido Da',
        validTo: 'Valido A',
        source: 'Sorgente',
        atcCode: 'Codice ATC',
        antibiotic: 'Antibiotico',
        class: 'Classe',
        category: 'Categoria',
        listedEML: 'Lista EML',
        maCode: 'Codice Materiale',
        maName: 'Nome Materiale',
        moCode: 'Codice MO',
        moGroup: 'Gruppo MO',
        moMicroorganism: 'Microrganismo',
        moMinimalList: 'Lista Minimale',
        enableWarn: 'Abilita Warning',
        sourceText: 'Testo Sorgente LIS',
        mechanism: 'Meccanismo',
        mic: 'MIC',
        notes: 'Note',
        warnEnabled: 'Warning Attivo',
        alertEnabled: 'Alert Attivo',
        actions: 'Azioni',
        analisiCode: 'Codice Analisi',
        analisiDescription: 'Descrizione Analisi',
        
        // Source types
        who: 'WHO',
        local: 'LOCAL',
        lis: 'LIS',
        manual: 'MANUAL',
        
        // Excel import
        selectExcelFile: 'Seleziona File Excel',
        dragDropExcel: 'Trascina qui il file Excel o clicca per selezionare',
        supportedFormats: 'Formati supportati: .xlsx, .xls',
        uploadInProgress: 'Caricamento in corso...',
        uploadCompleted: 'Caricamento completato',
        uploadFailed: 'Caricamento fallito',
        
        // Validation messages
        invalidData: 'Dati non validi',
        requiredField: 'Campo obbligatorio',
        invalidFormat: 'Formato non valido',
        duplicateEntry: 'Voce duplicata',
        foreignKeyError: 'Errore chiave esterna',
        
        // Confirmation dialogs
        confirmDelete: 'Conferma Eliminazione',
        confirmDeleteMessage: 'Sei sicuro di voler eliminare questa voce? (SCD Type 2: verrà impostato ValidTo)',
        confirmSave: 'Conferma Salvataggio',
        confirmSaveMessage: 'Salvare le modifiche?',
        unsavedChanges: 'Modifiche Non Salvate',
        unsavedChangesMessage: 'Ci sono modifiche non salvate. Continuare?',
        
        // Success messages
        saveSuccess: 'Salvataggio Completato',
        saveSuccessMessage: 'Le modifiche sono state salvate con successo',
        deleteSuccess: 'Eliminazione Completata',
        deleteSuccessMessage: 'La voce è stata eliminata con successo',
        importSuccess: 'Importazione Completata',
        importSuccessMessage: '{count} righe importate con successo',
        
        // Error messages
        saveError: 'Errore Salvataggio',
        saveErrorMessage: 'Si è verificato un errore durante il salvataggio',
        deleteError: 'Errore Eliminazione',
        deleteErrorMessage: 'Si è verificato un errore durante l\'eliminazione',
        importError: 'Errore Importazione',
        importErrorMessage: 'Si è verificato un errore durante l\'importazione',
        loadError: 'Errore Caricamento',
        loadErrorMessage: 'Si è verificato un errore durante il caricamento dei dati',
        networkError: 'Errore di Rete',
        networkErrorMessage: 'Impossibile contattare il server',
        
        // Loading states
        loading: 'Caricamento...',
        saving: 'Salvataggio...',
        deleting: 'Eliminazione...',
        importing: 'Importazione...',
        processing: 'Elaborazione...',
        
        // Empty states
        noData: 'Nessun Dato',
        noDataAvailable: 'Nessun dato disponibile',
        noRecordsFound: 'Nessun record trovato',
        
        // SCD Type 2 info
        scdType2Info: 'Questo vocabolario utilizza SCD Type 2 per il versioning',
        scdType2Description: 'Le modifiche creano nuove versioni mantenendo lo storico',
        currentVersion: 'Versione Corrente',
        historicalVersion: 'Versione Storica',
        viewHistory: 'Visualizza Storico',
        
        // Excel template
        downloadTemplate: 'Scarica Template',
        downloadTemplateDescription: 'Scarica un file Excel di esempio con la struttura corretta',
        
        // Pagination
        showing: 'Mostrando',
        of: 'di',
        records: 'record',
        rowsPerPage: 'Righe per pagina',
        
        // Tips and help
        tip: 'Suggerimento',
        help: 'Aiuto',
        documentation: 'Documentazione',
        excelImportTip: 'Il file Excel deve contenere le colonne esatte come mostrato nella tabella',
        scdType2Tip: 'Le modifiche non sovrascrivono i dati ma creano nuove versioni',
        sourceColumnTip: 'Indica l\'origine del dato: WHO (OMS), LOCAL (locale), LIS (da laboratorio)',
        
        // Boolean values
        yes: 'Sì',
        no: 'No',
        true: 'Vero',
        false: 'Falso',
        enabled: 'Abilitato',
        disabled: 'Disabilitato',
        active: 'Attivo',
        inactive: 'Inattivo',
        
        // LIS Alert Assignment - Filters
        testCodeLabel: 'Codice Esame',
        testCodePlaceholder: 'Codice...',
        materialLabel: 'Materiale',
        materialPlaceholder: 'Materiale...',
        microorganismLabel: 'Microrganismo',
        microorganismPlaceholder: 'Microrganismo...',
        fromDateLabel: 'Data Da',
        toDateLabel: 'Data A',
        businessUnit: 'Unità Operativa',
        testDescription: 'Descrizione Analisi',
        microbeName: 'Descrizione Microrganismo',
        antibioticName: 'Descrizione Antibiotico',
        searchButton: "Cerca",
        resetButton: "Reset",
        female: 'Femmina',
        male: 'Maschio',

        requestId: 'ID Richiesta',
        admittanceDate: 'Data Accettazione',
        gender: 'Genere',
        department: 'Unità Operativa',
        testDescription: 'Descrizione Analisi',
        materialDescription: 'Descrizione Materiale',
        provenanceDescription: 'Descrizione Provenienza',
        microDescription: 'Descrizione Microrganismo',
        antibioticDescription: 'Descrizione Antibiotico',

        admittanceFromDate: 'Data Accettazione da',
        admittanceToDate: 'Data Accettazione a',
        hasErrors: 'Contiene errori',
        noErrors: 'Nessun errore',
        lisAlertAssignment: 'Assegnazione Alert LIS',
        lisAlertAssignmentDescription: 'Assegna alert LIS agli utenti',
        filterStatus: 'Filtro Stato',
    },
    
    en: {
        // Page title and sections
        lisAlertManagement: 'LIS Alert Management',
        filterStatus: 'Filter Status',
        searchButton: "Search",
        resetButton: "Reset",
        lisAlertManagementDescription: 'Manage LIS vocabularies, mappings and alert rules',
        vocabularyManagement: 'Vocabulary Management',
        statusMonitor: 'Status Monitor',
        systemStatusMonitor: 'System Status Monitor',
        systemStatusMonitorDescription: 'Monitor the status of the systems',
        "LIS Source Data Table": "LIS Source Data Table",
        "Manage source data table records": "Manage source data table records",
        errorLegendTitle: "Errors Legend",
        // System Status Monitor (new)
        sourceDataImportSection: 'Source Data Import',
        dataAnalysisVerificationSection: 'Data Analysis/Verification Job',
        lisToAiPlanLocalDbTitle: 'LIS to AI-Plan local DB',
        postImportProcessingTitle: 'Post-import processing',
        statusRunningBadge: 'STATUS: RUNNING',
        statusIdleBadge: 'STATUS: IDLE',
        lastImportEnded: 'Last Import Ended',
        lisAlertAssignment: 'LIS Alert Assignment',
        lisAlertAssignmentDescription: 'Assign LIS alerts to users',
        // Job status labels
        sourceDataImport: 'Source Data Import (LIS → AI-PLAN Local DB)',
        dataAnalysisJob: 'Data Analysis/Verification Job (Post-Import)',
        status: 'Status',
        lastImportStarted: 'Last Import Started',
        lastStatus: 'Last Status',
        details: 'Details',
        noErrorsReported: 'No errors reported',

        female: 'Female',
        male: 'Male',
        // Status values
        idle: 'IDLE',
        running: 'RUNNING',
        completed: 'COMPLETED',
        failed: 'FAILED',
        ok: 'OK',
        error: 'Error',
        notAvailable: 'N/A',
        ATC_Code: 'ATC Code',
        Antibiotic: 'Antibiotic',
        Class: 'Class',
        Category: 'Category',
        ListedEML: 'Listed EML',
        
        // Vocabulary types
        antibiotics: 'Antibiotics',
        antibioticsVoc: 'AWARE Antibiotics Vocabulary',
        materials: 'Materials',
        materialsVoc: 'Materials Vocabulary',
        microorganisms: 'Microorganisms',
        microorganismsVoc: 'Microorganisms Vocabulary',
        antibioticsMap: 'Antibiotics Mapping',
        antibioticsMapping: 'LIS → AWARE Antibiotics Mapping',
        materialsMap: 'Materials Mapping',
        materialsMapping: 'LIS → Materials Mapping',
        microorganismsMap: 'Microorganisms Mapping',
        microorganismsMapping: 'LIS → Microorganisms Mapping',
        alertRules: 'Alert Rules',
        alertRulesManagement: 'Alert Rules Management',
        provenienza: 'Provenance',
        provenienzaVoc: 'Provenance Vocabulary',
        analisi: 'Analysis',
        analisiVoc: 'Microbiology Analysis Vocabulary',
        analisiMapping: 'Analysis Mapping',
        requestId: 'Request ID',
        admittanceDate: 'Admittance Date',
        gender: 'Gender',
        department: 'Business Unit',
        testDescription: 'Test Description',
        materialDescription: 'Material Description',
        provenanceDescription: 'Provenance Description',
        microDescription: 'Micro Description',
        antibioticDescription: 'Antibiotic Description',
        
        // Actions
        addRow: 'Add Row',
        importFromExcel: 'Import from Excel',
        exportToExcel: 'Export to Excel',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        refresh: 'Refresh',
        download: 'Download',
        upload: 'Upload',
        saveChanges: 'Save Changes',
        saveAllChanges: 'Save all changes',
        noChangesToSave: 'No changes to save',
        cancelEditing: 'Cancel editing',
        replaceVocabulary: 'Import Vocabulary',
        saveVocabulary: 'Save Vocabulary',
        selectVocabularyToEdit: 'Select vocabulary to edit',
        editing: 'Editing',
        viewing: 'Viewing',
        importProgress: 'Import progress',
        activeNull: 'Active (NULL)',
        primaryKeyReadonly: 'Primary key - cannot be modified',
        
        // Table columns
        validFrom: 'Valid From',
        validTo: 'Valid To',
        source: 'Source',
        atcCode: 'ATC Code',
        antibiotic: 'Antibiotic',
        class: 'Class',
        category: 'Category',
        listedEML: 'EML Listed',
        maCode: 'Material Code',
        maName: 'Material Name',
        moCode: 'MO Code',
        moGroup: 'MO Group',
        moMicroorganism: 'Microorganism',
        moMinimalList: 'Minimal List',
        enableWarn: 'Enable Warning',
        sourceText: 'LIS Source Text',
        mechanism: 'Mechanism',
        mic: 'MIC',
        notes: 'Notes',
        warnEnabled: 'Warning Enabled',
        alertEnabled: 'Alert Enabled',
        actions: 'Actions',
        analisiCode: 'Analysis Code',
        analisiDescription: 'Analysis Description',
        
        // Source types
        who: 'WHO',
        local: 'LOCAL',
        lis: 'LIS',
        manual: 'MANUAL',
        
        // Excel import
        selectExcelFile: 'Select Excel File',
        dragDropExcel: 'Drag Excel file here or click to select',
        supportedFormats: 'Supported formats: .xlsx, .xls',
        uploadInProgress: 'Upload in progress...',
        uploadCompleted: 'Upload completed',
        uploadFailed: 'Upload failed',
        
        // Validation messages
        invalidData: 'Invalid data',
        requiredField: 'Required field',
        invalidFormat: 'Invalid format',
        duplicateEntry: 'Duplicate entry',
        foreignKeyError: 'Foreign key error',
        
        // Confirmation dialogs
        confirmDelete: 'Confirm Deletion',
        confirmDeleteMessage: 'Are you sure you want to delete this entry? (SCD Type 2: ValidTo will be set)',
        confirmSave: 'Confirm Save',
        confirmSaveMessage: 'Save changes?',
        unsavedChanges: 'Unsaved Changes',
        unsavedChangesMessage: 'There are unsaved changes. Continue?',
        
        // Success messages
        saveSuccess: 'Save Completed',
        saveSuccessMessage: 'Changes saved successfully',
        deleteSuccess: 'Deletion Completed',
        deleteSuccessMessage: 'Entry deleted successfully',
        importSuccess: 'Import Completed',
        importSuccessMessage: '{count} rows imported successfully',
        
        // Error messages
        saveError: 'Save Error',
        saveErrorMessage: 'An error occurred while saving',
        deleteError: 'Delete Error',
        deleteErrorMessage: 'An error occurred while deleting',
        importError: 'Import Error',
        importErrorMessage: 'An error occurred during import',
        loadError: 'Load Error',
        loadErrorMessage: 'An error occurred while loading data',
        networkError: 'Network Error',
        networkErrorMessage: 'Unable to contact server',
        
        // Loading states
        loading: 'Loading...',
        saving: 'Saving...',
        deleting: 'Deleting...',
        importing: 'Importing...',
        processing: 'Processing...',
        
        // Empty states
        noData: 'No Data',
        noDataAvailable: 'No data available',
        noRecordsFound: 'No records found',
        
        // SCD Type 2 info
        scdType2Info: 'This vocabulary uses SCD Type 2 for versioning',
        scdType2Description: 'Changes create new versions while maintaining history',
        currentVersion: 'Current Version',
        historicalVersion: 'Historical Version',
        viewHistory: 'View History',
        
        // Excel template
        downloadTemplate: 'Download Template',
        downloadTemplateDescription: 'Download a sample Excel file with the correct structure',
        
        // Pagination
        showing: 'Showing',
        of: 'of',
        records: 'records',
        rowsPerPage: 'Rows per page',
        
        // Tips and help
        tip: 'Tip',
        help: 'Help',
        documentation: 'Documentation',
        excelImportTip: 'The Excel file must contain the exact columns as shown in the table',
        scdType2Tip: 'Changes do not overwrite data but create new versions',
        sourceColumnTip: 'Indicates data origin: WHO (World Health Org), LOCAL (local), LIS (from lab)',
        
        // Boolean values
        yes: 'Yes',
        no: 'No',
        true: 'True',
        false: 'False',
        enabled: 'Enabled',
        disabled: 'Disabled',
        active: 'Active',
        inactive: 'Inactive',
        
        // LIS Alert Assignment - Filters
        testCodeLabel: 'Test Code',
        testCodePlaceholder: 'Code...',
        materialLabel: 'Material',
        materialPlaceholder: 'Material...',
        microorganismLabel: 'Microorganism',
        microorganismPlaceholder: 'Microorganism...',
        fromDateLabel: 'Date From',
        toDateLabel: 'Date To',
        businessUnit: 'Business Unit',
        testDescription: 'Test Description',
        microbeName: 'Microorganism Name',
        antibioticName: 'Antibiotic Name',
        hasErrors: 'Has errors',
        noErrors: 'No errors',
        errorLegendTitle: "Errors Legend",

    }
};

/**
 * i18n labels for Microbiological Data Explorer screen.
 * Kept in this file to centralize LIS module translations in a single place.
 */
export const MicrobiologicalDataLabels = {
  it: {
    // Screen title and description
    screenTitle: "Dati LIS",
    screenDescription:
      "Visualizza ed esplora i dati microbiologici con struttura gerarchica",

    // Filters
    requestId: "ID Richiesta",
    filterTitle: "Filtri di ricerca",
    admittanceFromDate: "Data Accettazione da",
    admittanceToDate: "Data Accettazione a",
    businessUnit: "Unità Operativa",
    testDescription: "Descrizione Analisi",
    microbeName: "Descrizione Microrganismo",
    antibioticName: "Descrizione Antibiotico",
    errorFilter: "Mostra solo errori",
    searchButton: "Cerca",
    clearFiltersButton: "Pulisci filtri",

    // Table headers - Source data (NOMOS_ESTRAZIONIMICRO)
    requestId: "ID Richiesta",
    admittanceDate: "Data Accettazione",
    patient: "Paziente",
    sex: "Sesso",
    department: "Reparto",
    testCode: "Codice Analisi",
    actions: "Azioni",

    // Expandable details labels
    sourceDataTitle: "Dati Sorgente (NOMOS)",
    lisHeaderTitle: "Dati LIS - Header",
    lisMaterialsTitle: "Dati LIS - Materiali",
    lisItemsTitle: "Dati LIS - Microrganismi",
    lisAntibioticsTitle: "Dati LIS - Antibiotici",

    // Source data fields
    sourceId: "ID Sorgente",
    cryptedLastName: "Cognome (criptato)",
    cryptedName: "Nome (criptato)",
    departmentCode: "Codice Reparto",
    departmentDescription: "Descrizione Reparto",
    analysisCode: "Codice Analisi",
    analysisDescription: "Descrizione Analisi",
    materialCode: "Codice Materiale",
    materialDescription: "Descrizione Materiale",
    provenanceCode: "Codice Provenienza",
    provenanceDescription: "Descrizione Provenienza",
    microCode: "Codice Microrganismo",
    microDescription: "Descrizione Microrganismo",
    antibioticCode: "Codice Antibiotico",
    antibioticDescription: "Descrizione Antibiotico",
    rsi: "RSI",
    mic: "MIC",

    // LIS Header fields
    headerId: "ID Header",
    lisId: "LIS ID",
    patientId: "ID Paziente",
    patientName: "Nome Paziente",
    patientLastName: "Cognome Paziente",
    patientSex: "Sesso Paziente",
    businessUnitName: "Nome Unità Operativa",
    businessUnitCode: "Codice Unità Operativa",

    // LIS Materials fields
    materialId: "ID Materiale",
    materialCodeStd: "Codice Materiale Standardizzato",
    materialSourceText: "Testo Materiale Sorgente",
    provenanceCodeStd: "Codice Provenienza Standardizzato",
    provenanceSourceText: "Testo Provenienza Sorgente",

    // LIS Items fields
    itemId: "ID Item",
    moCode: "Codice Microrganismo",
    microorganismDescription: "Descrizione Microrganismo",
    isSentinelPathogen: "Patogeno Sentinella",
    open: "Aperto",

    // LIS Antibiotics fields
    antibioticId: "ID Antibiotico",
    atcCode: "Codice ATC",
    atcLevel1: "ATC Livello 1",
    atcLevel2: "ATC Livello 2",
    gender: "Genere",
    male: "Maschio",
    female: "Femmina",

    // Error flags
    errors: "Error",
    hasErrors: "Contiene errori",
    noErrors: "Nessun errore",
    departmentError: "Errore Reparto",
    materialError: "Errore Materiale",
    provenanceError: "Errore Provenienza",
    microError: "Errore Microrganismo",
    antibioticError: "Errore Antibiotico",
    analysisError: "Errore Analisi",

    // Error tooltips (detailed explanations)
    departmentErrorTooltip:
      "Il reparto non è stato trovato nel vocabolario standardizzato. Verificare la mappatura del codice reparto.",
    materialErrorTooltip:
      "Il materiale non è stato trovato nel vocabolario standardizzato. Verificare la mappatura del codice materiale.",
    provenanceErrorTooltip:
      "La provenienza del campione non è stata trovata nel vocabolario standardizzato. Verificare la mappatura del codice provenienza.",
    microErrorTooltip:
      "Il microrganismo non è stato trovato nel vocabolario standardizzato. Verificare la mappatura del codice microrganismo.",
    antibioticErrorTooltip:
      "L'antibiotico non è stato trovato nel vocabolario standardizzato. Verificare la mappatura del codice ATC.",
    analysisErrorTooltip:
      "L'analisi non è stata trovata nel vocabolario standardizzato. Verificare la mappatura del codice analisi.",

    // Error legend
    errorLegendTitle: "Legenda Errori",
    errorLegendDescription:
      "Gli errori indicano che i dati non corrispondono ai vocabolari standardizzati di AI-PLAN. Questi dati devono essere mappati manualmente prima di poter essere elaborati correttamente.",

    // Actions
    expandDetails: "Espandi dettagli",
    collapseDetails: "Comprimi dettagli",
    viewLisData: "Visualizza dati LIS",
    loadingDetails: "Caricamento dettagli...",

    // Messages
    noDataFound: "Nessun dato trovato",
    noLisDataAvailable: "Dati LIS non ancora elaborati",
    loadingData: "Caricamento dati in corso...",
    errorLoadingData: "Errore nel caricamento dei dati",
    errorLoadingDetails: "Errore nel caricamento dei dettagli",

    // Pagination
    page: "Pagina",
    of: "di",
    previousRecord: "Record precedente",
    nextRecord: "Record successivo",
    closeDrawer: "Chiudi",
    itemsPerPage: "Elementi per pagina",
    showing: "Visualizzati",
    to: "a",
    totalRecords: "record totali",

    // Status badges
    processed: "Elaborato",
    notProcessed: "Non elaborato",
    withErrors: "Con errori",

    // Tooltips
    expandTooltip: "Clicca per espandere e vedere i dettagli LIS",
    errorTooltip: "Questo record contiene errori di validazione",
    sentinelTooltip: "Questo è un patogeno sentinella che richiede attenzione",
  },

  en: {
    // Screen title and description
    screenTitle: "LIS Data",
    screenDescription:
      "View and explore microbiology data with hierarchical structure",

    // Filters
    filterTitle: "Search filters",
    admittanceFromDate: " Admittance from date",
    admittanceToDate: "Admittance to date",
    gender: "Gender",
    male: "Male",
    female: "Female",
    businessUnit: "Business Unit",
    testDescription: "Test Description",
    microbeName: "Microorganism Name",
    antibioticName: "Antibiotic Name",
    errorFilter: "Show only errors",
    searchButton: "Search",
    clearFiltersButton: "Clear filters",

    // Table headers - Source data (NOMOS_ESTRAZIONIMICRO)
    requestId: "Request ID",
    admittanceDate: "Admittance Date",
    patient: "Patient",
    sex: "Gender",
    department: "Business Unit",
    testCode: "Test Code",
    actions: "Actions",

    // Expandable details labels
    sourceDataTitle: "Source Data (NOMOS)",
    lisHeaderTitle: "LIS Data - Header",
    lisMaterialsTitle: "LIS Data - Materials",
    lisItemsTitle: "LIS Data - Microorganisms",
    lisAntibioticsTitle: "LIS Data - Antibiotics",

    // Source data fields
    sourceId: "Source ID",
    cryptedLastName: "Last Name (encrypted)",
    cryptedName: "Name (encrypted)",
    departmentCode: "Department Code",
    departmentDescription: "Department Description",
    analysisCode: "Analysis Code",
    analysisDescription: "Analysis Description",
    materialCode: "Material Code",
    materialDescription: "Material Description",
    provenanceCode: "Provenance Code",
    provenanceDescription: "Provenance Description",
    microCode: "Microorganism Code",
    microDescription: "Microorganism Description",
    antibioticCode: "Antibiotic Code",
    antibioticDescription: "Antibiotic Description",
    rsi: "RSI",
    mic: "MIC",

    // LIS Header fields
    headerId: "Header ID",
    lisId: "LIS ID",
    patientId: "Patient ID",
    patientName: "Patient Name",
    patientLastName: "Patient Last Name",
    patientSex: "Patient Sex",
    businessUnitName: "Business Unit Name",
    businessUnitCode: "Business Unit Code",

    // LIS Materials fields
    materialId: "Material ID",
    materialCodeStd: "Standardized Material Code",
    materialSourceText: "Source Material Text",
    provenanceCodeStd: "Standardized Provenance Code",
    provenanceSourceText: "Source Provenance Text",

    // LIS Items fields
    itemId: "Item ID",
    moCode: "Microorganism Code",
    microorganismDescription: "Microorganism Description",
    isSentinelPathogen: "Sentinel Pathogen",
    open: "Open",

    // LIS Antibiotics fields
    antibioticId: "Antibiotic ID",
    atcCode: "ATC Code",
    atcLevel1: "ATC Level 1",
    atcLevel2: "ATC Level 2",

    // Error flags
    errors: "Errors",
    hasErrors: "Has errors",
    noErrors: "No errors",
    departmentError: "Department Error",
    materialError: "Material Error",
    provenanceError: "Provenance Error",
    microError: "Microorganism Error",
    antibioticError: "Antibiotic Error",
    analysisError: "Analysis Error",

    // Error tooltips (detailed explanations)
    departmentErrorTooltip:
      "The department was not found in the standardized vocabulary. Please verify the department code mapping.",
    materialErrorTooltip:
      "The material was not found in the standardized vocabulary. Please verify the material code mapping.",
    provenanceErrorTooltip:
      "The sample provenance was not found in the standardized vocabulary. Please verify the provenance code mapping.",
    microErrorTooltip:
      "The microorganism was not found in the standardized vocabulary. Please verify the microorganism code mapping.",
    antibioticErrorTooltip:
      "The antibiotic was not found in the standardized vocabulary. Please verify the ATC code mapping.",
    analysisErrorTooltip:
      "The analysis was not found in the standardized vocabulary. Please verify the analysis code mapping.",

    // Error legend
    errorLegendTitle: "Error Legend",
    errorLegendDescription:
      "Errors indicate that data does not match AI-PLAN's standardized vocabularies. This data must be manually mapped before it can be processed correctly.",

    // Actions
    expandDetails: "Expand details",
    collapseDetails: "Collapse details",
    viewLisData: "View LIS data",
    loadingDetails: "Loading details...",

    // Messages
    noDataFound: "No data found",
    noLisDataAvailable: "LIS data not yet processed",
    loadingData: "Loading data...",
    errorLoadingData: "Error loading data",
    errorLoadingDetails: "Error loading details",

    // Pagination
    page: "Page",
    of: "of",
    previousRecord: "Previous record",
    nextRecord: "Next record",
    closeDrawer: "Close",
    itemsPerPage: "Items per page",
    showing: "Showing",
    to: "to",
    totalRecords: "total records",

    // Status badges
    processed: "Processed",
    notProcessed: "Not processed",
    withErrors: "With errors",

    // Tooltips
    expandTooltip: "Click to expand and view LIS details",
    errorTooltip: "This record contains validation errors",
    sentinelTooltip: "This is a sentinel pathogen requiring attention",
  },
};

/**
 * i18n labels for LIS Alert Notification Settings screen.
 * Used for managing email notification flags for LIS infection alerts.
 */
export const LisAlertNotificationLabels = {
  it: {
    // Screen title and description
    screenTitle: "Impostazioni Notifiche Alert LIS",
    subtitle: "Gestione Notifiche Email Alert ICA",

    // Filters
    filters: "Filtri di Ricerca",
    dateFrom: "Data Da",
    dateTo: "Data A",
    notificationStatus: "Stato Notifica",
    emailStatus: "Stato Email",
    all: "Tutti",
    enabled: "Abilitato",
    disabled: "Disabilitato",
    notSent: "Non Inviate",
    sent: "Inviate",
    search: "Cerca",
    clearFilters: "Pulisci Filtri",
    refresh: "Aggiorna",

    // Table headers
    date: "Data",
    patient: "Paziente",
    microorganism: "Microrganismo",
    material: "Materiale",
    businessUnit: "Unità Operativa",
    notify: "Notifica",
    status: "Stato",

    // Status badges
    pending: "In Attesa",
    emailSent: "Email inviata",
    pendingEmail: "Email in attesa di invio",
    notificationsDisabled: "Notifiche disabilitate",

    // Bulk actions
    selectedItems: "elementi selezionati",
    enableSelected: "Abilita Selezionati",
    disableSelected: "Disabilita Selezionati",
    clearSelection: "Annulla Selezione",

    // Toggle tooltips
    clickToEnable: "Clicca per abilitare le notifiche",
    clickToDisable: "Clicca per disabilitare le notifiche",
    cannotModifyNotified: "Impossibile modificare: email già inviata",

    // Confirmation dialogs
    confirmBulkTitle: "Conferma Modifica Massiva",
    confirmBulkEnable: "Sei sicuro di voler abilitare le notifiche per {count} alert?",
    confirmBulkDisable: "Sei sicuro di voler disabilitare le notifiche per {count} alert?",
    confirm: "Conferma",
    cancel: "Annulla",
    continue: "Continua",

    // Warning messages
    bulkWarningTitle: "Attenzione: Alcuni Alert Non Modificabili",
    bulkWarningMessage: "Alcuni degli alert selezionati hanno già ricevuto notifica email e non possono essere modificati.",
    alreadyNotified: "Già notificati",
    canBeModified: "Modificabili",
    noSelectionTitle: "Nessuna Selezione",
    noSelectionMessage: "Seleziona almeno un alert prima di procedere.",
    noValidSelectionTitle: "Nessun Alert Modificabile",
    noValidSelectionMessage: "Tutti gli alert selezionati hanno già ricevuto notifica email.",
    cannotModifyTitle: "Modifica Non Consentita",

    // Success messages
    successTitle: "Operazione Completata",
    notificationEnabled: "Notifica abilitata con successo",
    notificationDisabled: "Notifica disabilitata con successo",
    bulkUpdateSuccess: "{count} alert aggiornati con successo",

    // Loading states
    loading: "Caricamento...",
    updatingTitle: "Aggiornamento in corso",
    updatingMessage: "Attendere prego...",

    // Error messages
    errorTitle: "Errore",
    errorLoadingData: "Errore nel caricamento dei dati",

    // Empty states
    noData: "Nessun alert trovato",

    // Pagination
    page: "Pagina",
    of: "di",
    records: "record",
    
    // LIS SOURCE DATA TABLE - Filters
    fromDateLabel: 'Data Da',
    toDateLabel: 'Data A',
    businessUnitLabel: 'Unità Operativa',
    testDescriptionLabel: 'Descrizione Esame',
    microbeNameLabel: 'Descrizione Microrganismo',
    antibioticNameLabel: 'Descrizione Antibiotico',
    errorLabel: 'Errore',
    trueLabel: 'True',
    falseLabel: 'False',

    // Help section
    help: "Aiuto",
    helpTitle: "Guida alle Impostazioni Notifiche",
    helpSection1Title: "Cosa sono le notifiche alert?",
    helpSection1Text: "Le notifiche alert inviano automaticamente email ai responsabili quando vengono rilevati microrganismi critici (es. MRSA, VRE). Puoi abilitare o disabilitare le notifiche per singoli alert.",
    helpSection2Title: "Come modificare le notifiche?",
    helpSection2Text: "Usa l'interruttore nella colonna 'Notifica' per abilitare/disabilitare notifiche per singoli alert. Per modifiche massive, seleziona più alert con le checkbox e usa i pulsanti 'Abilita Selezionati' o 'Disabilita Selezionati'.",
    helpSection3Title: "Limitazioni",
    helpSection3Text: "Non è possibile modificare alert per cui è già stata inviata un'email. Questi alert sono contrassegnati con lo stato 'Inviate' e hanno l'interruttore disabilitato.",
  },

  en: {
    // Screen title and description
    screenTitle: "LIS Alert Notification Settings",
    subtitle: "ICA Alert Email Notifications Management",

        // LIS SOURCE DATA TABLE - Filters
        fromDate: 'Date From',
        toDate: 'Date To',
        businessUnit: 'Business Unit',
        testDescription: 'Test Description',
        microbeName: 'Microorganism Name',
        antibioticName: 'Antibiotic Name',
        error: 'Error',
        true: 'True',
        false: 'False',

    // Filters
    filters: "Search Filters",
    dateFrom: "Date From",
    dateTo: "Date To",
    notificationStatus: "Notification Status",
    emailStatus: "Email Status",
    all: "All",
    enabled: "Enabled",
    disabled: "Disabled",
    notSent: "Not Sent",
    sent: "Sent",
    search: "Search",
    clearFilters: "Clear Filters",
    refresh: "Refresh",

    // Table headers
    date: "Date",
    patient: "Patient",
    microorganism: "Microorganism",
    material: "Material",
    businessUnit: "Business Unit",
    notify: "Notify",
    status: "Status",

    // Status badges
    pending: "Pending",
    emailSent: "Email sent",
    pendingEmail: "Email pending",
    notificationsDisabled: "Notifications disabled",

    // Bulk actions
    selectedItems: "items selected",
    enableSelected: "Enable Selected",
    disableSelected: "Disable Selected",
    clearSelection: "Clear Selection",

    // Toggle tooltips
    clickToEnable: "Click to enable notifications",
    clickToDisable: "Click to disable notifications",
    cannotModifyNotified: "Cannot modify: email already sent",

    // Confirmation dialogs
    confirmBulkTitle: "Confirm Bulk Update",
    confirmBulkEnable: "Are you sure you want to enable notifications for {count} alerts?",
    confirmBulkDisable: "Are you sure you want to disable notifications for {count} alerts?",
    confirm: "Confirm",
    cancel: "Cancel",
    continue: "Continue",

    // Warning messages
    bulkWarningTitle: "Warning: Some Alerts Cannot Be Modified",
    bulkWarningMessage: "Some of the selected alerts have already been notified via email and cannot be modified.",
    alreadyNotified: "Already notified",
    canBeModified: "Can be modified",
    noSelectionTitle: "No Selection",
    noSelectionMessage: "Please select at least one alert before proceeding.",
    noValidSelectionTitle: "No Modifiable Alerts",
    noValidSelectionMessage: "All selected alerts have already been notified via email.",
    cannotModifyTitle: "Modification Not Allowed",

    // Success messages
    successTitle: "Operation Completed",
    notificationEnabled: "Notification enabled successfully",
    notificationDisabled: "Notification disabled successfully",
    bulkUpdateSuccess: "{count} alerts updated successfully",

    // Loading states
    loading: "Loading...",
    updatingTitle: "Updating",
    updatingMessage: "Please wait...",

    // Error messages
    errorTitle: "Error",
    errorLoadingData: "Error loading data",

    // Empty states
    noData: "No alerts found",

    // Pagination
    page: "Page",
    of: "of",
    records: "records",

    // Help section
    help: "Help",
    helpTitle: "Notification Settings Guide",
    helpSection1Title: "What are alert notifications?",
    helpSection1Text: "Alert notifications automatically send emails to supervisors when critical microorganisms are detected (e.g., MRSA, VRE). You can enable or disable notifications for individual alerts.",
    helpSection2Title: "How to modify notifications?",
    helpSection2Text: "Use the toggle switch in the 'Notify' column to enable/disable notifications for individual alerts. For bulk changes, select multiple alerts with checkboxes and use the 'Enable Selected' or 'Disable Selected' buttons.",
    helpSection3Title: "Limitations",
    helpSection3Text: "You cannot modify alerts for which an email has already been sent. These alerts are marked with 'Sent' status and have the toggle switch disabled.",
  },
};

